<template>

  <a 
    href="javascript:void(0)" 
    @click="resendInvite()"
    :class="{'box-loading': loading}">
    {{ $t('Resend invitation') }}
    </a>
 
</template>

<script>
export default {
  name: 'MemberInviteResendInvite',
  components: {
  },
  props: [
    'memberInvite'
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    resendInvite () {
      this.loading = true

      this.$store
      .dispatch('resendInvite', this.memberInvite._id)
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberInviteResendInvite.vue